import React from 'react'
import styles from './AboutHeader.module.scss'

const AboutHeader = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['glow']} aria-hidden='true' />
      <div className={styles['header']}>
        <span className={styles['eyebrow']}>About Socommerz</span>
        <h1 className={styles['heading']}>
          We back the people who
          <br />
          <span className={styles['gradient']}>build what comes next</span>
        </h1>
        <p className={styles['sub-heading']}>
          Do you bet on the horse or the jockey? We&apos;re here to tell you
          that the answer is neither. While the horse&apos;s athleticism will be
          hailed as the fastest and the jockey&apos;s skill and dedication will
          be lauded for crossing the finish line first, the true bet lies in the
          trainer who is bringing the horse and the jockey together for the
          perfect fit.
        </p>
      </div>
    </div>
  )
}

export default AboutHeader
